// extracted by mini-css-extract-plugin
export default {"banner":"banner__WAiHn"};